import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api, LOGO_URL } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Eye, EyeOff } from "lucide-react";

function describe(detail) {
  if (!detail) return "Error";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error("La contraseña debe tener al menos 8 caracteres"); return; }
    if (pw !== pw2) { toast.error("Las contraseñas no coinciden"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Contraseña actualizada");
      setDone(true);
      setTimeout(() => nav("/login", { replace: true }), 1500);
    } catch (err) {
      toast.error(describe(err?.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAF7] p-6" data-testid="reset-page">
      <div className="w-full max-w-md bg-white border border-border rounded-xl shadow-sm overflow-hidden">
        <div className="bg-[#F4F2EC] p-6 border-b border-border text-center">
          <img src={LOGO_URL} alt="Madera Blanca Studio" className="h-14 mx-auto mb-2 object-contain" />
          <div className="uppercase-label text-[#8B5A33]">Madera Blanca Studio</div>
        </div>
        <div className="p-8">
          <h1 className="font-display text-3xl mb-5">Nueva contraseña</h1>
          {!token ? (
            <p className="text-sm text-[#8a3537]">Enlace inválido. Solicita uno nuevo desde la pantalla de inicio.</p>
          ) : done ? (
            <p className="text-sm text-[#3a6347]">Tu contraseña fue actualizada. Redirigiendo…</p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label>Contraseña nueva</Label>
                <div className="relative">
                  <Input type={show ? "text" : "password"} value={pw} onChange={(e) => setPw(e.target.value)} required data-testid="reset-pw" />
                  <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground p-1" tabIndex={-1}>
                    {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>
              <div className="space-y-2">
                <Label>Confirmar contraseña</Label>
                <Input type={show ? "text" : "password"} value={pw2} onChange={(e) => setPw2(e.target.value)} required data-testid="reset-pw2" />
              </div>
              <Button type="submit" className="w-full bg-[#8B5A33] hover:bg-[#6D4525] text-white" disabled={busy} data-testid="reset-submit">
                {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
                Guardar contraseña
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
